exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes slide {\n  10% {\n    min-width: 350px; }\n  80% {\n    min-width: 350px; }\n  100% {\n    min-width: 0; } }\n\n@keyframes slide {\n  10% {\n    min-width: 350px; }\n  80% {\n    min-width: 350px; }\n  100% {\n    min-width: 0; } }\n\n.omni-container-slider:hover {\n  min-width: 350px; }\n\n.omni-container-slider {\n  min-width: 0px;\n  -webkit-transition: 1s !important;\n  -o-transition: 1s !important;\n  transition: 1s !important;\n  text-align: justify; }\n\n#omni-hide-chat-button {\n  z-index: 99999; }\n", ""]);

// exports
